import React, { useEffect, useState } from 'react';
import DspxModal from '../../../common/DspxModal/DspxModal';
import styles from './AllTenantDocumentsModal.module.scss';
import { TenantDocumentList } from './components/TenantDocumentList/TenantDocumentList';
import useClientDocumentTypes from '../../../../queries/useClientDocumentTypes';
import { Spin } from 'antd';

export const AllTenantDocumentsModal = ({ visible, clientId, ...props }) => {
  const [clientDocumentTypesList, setClientDocumentTypesList] = useState([]);

  const {
    data: clientDocumentTypes,
    isFetching: isFetchingClientDocumentTypes,
  } = useClientDocumentTypes({
    enabled: visible,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (clientDocumentTypes && !!clientDocumentTypes.length) {
      setClientDocumentTypesList(clientDocumentTypes);
    }
  }, [clientDocumentTypes]);

  return (
    <DspxModal
      title="Документы"
      destroyOnClose
      footer={null}
      visible={visible}
      {...props}
    >
      <div className={styles.root}>
        <Spin spinning={isFetchingClientDocumentTypes}>
          <TenantDocumentList
            visible={visible}
            clientId={clientId}
            documentTypes={clientDocumentTypesList}
          />
        </Spin>
      </div>
    </DspxModal>
  );
};
